import { useDirektIbCookieHandler } from '../../../common/js/composables/direkt-ib-cookie-handler';
import messages from './netbank-login-qr-lang.json';
export default {
	props: {
		otpdirektUrl: {
			required: true
		},
		linkError: {
			required: true
		},
		qrCodeUrl: {
			required: true
		},
		structureId: {
			required: true
		}
	},
	i18n: { messages },
	setup() {
		const { setDirektCookie } = useDirektIbCookieHandler();
		return {
			setDirektCookie
		};
	},
	computed: {
		hasEditedError() {
			return this.$slots.default;
		},
		qrUrl() {
			const hasParams = this.qrCodeUrl.includes('?');
			const stucturePart = this.structureId ? 'structureId=' + this.structureId : '';
			const separator = this.structureId && hasParams ? `&` : `?`;
			const structureParam = `${separator}${stucturePart}`;
			return `${this.otpdirektUrl}${this.qrCodeUrl}${this.structureId ? structureParam : ''}`;
		}
	}
};
